export { default } from './MobilePhone';
